import axiosInstance from "@/api/axiosInstance";

export const fetchProductOrders = async (params: Record<string, any>) => {
  const response = await axiosInstance.get("/api/private/product-orders", { params });
  return response.data;
};

export const fetchProductOrderByUuid = async (uuid: string) => {
  const response = await axiosInstance.get(`/api/private/product-order/${uuid}`);
  return response.data;
};

export const updateOrderItemShipment = async (
  itemId: number,
  data: { isShipped: boolean; trackingNumber?: string; notes?: string },
) => {
  const response = await axiosInstance.patch(`/api/private/product-order-item/${itemId}/shipment`, data);
  return response.data;
};
